module.exports = __webpack_public_path__ + "static/2-0115caf673ecbd0b469abd7d8e8b5965.jpg";